import { makeStyles } from '@material-ui/core/styles';

const getDrawerWidth = (isMobile) => {
  let drawerWith = isMobile ? 120 : 240
  drawerWith += 'px'
  return drawerWith
}

const styles = makeStyles({
  root: {
    display: 'flex',
  },
  appBar: props => ({
    zIndex: props.theme.zIndex.drawer + 1,
    transition: props.theme.transitions.create(['width', 'margin'], {
      easing: props.theme.transitions.easing.sharp,
      duration: props.theme.transitions.duration.leavingScreen,
    }),
  }),
  appBarShift: props => ({
    marginLeft: getDrawerWidth(props.isMobile),
    width: `calc(100% - ${getDrawerWidth(props.isMobile)}px)`,
    transition: props.theme.transitions.create(['width', 'margin'], {
      easing: props.theme.transitions.easing.sharp,
      duration: props.theme.transitions.duration.enteringScreen,
    }),
  }),
  menuButton: props => ({
    marginRight: 36,
  }),
  // hide: props => ({
  //   display: 'none',
  // }),
  drawer: props => ({
    width: getDrawerWidth(props.isMobile),
    flexShrink: 0,
    whiteSpace: 'nowrap',
  }),
  drawerOpen: props => ({
    width: getDrawerWidth(props.isMobile),
    transition: props.theme.transitions.create('width', {
      easing: props.theme.transitions.easing.sharp,
      duration: props.theme.transitions.duration.enteringScreen,
    }),
    opacity: 1,
    visibility: 'visible',
  }),
  drawerClose: props => ({
    transition: props.theme.transitions.create('width', {
      easing: props.theme.transitions.easing.sharp,
      duration: props.theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: props.theme.spacing(4) - 32,
    opacity: 0,
    visibility: 'hidden',
    [props.theme.breakpoints.up('sm')]: {
      width: props.theme.spacing(8) - 64,
      opacity: 0,
      visibility: 'hidden',
    },
  }),
  toolbar: props => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: props.theme.spacing(0, 0),
    // necessary for content to be below app bar
    ...props.theme.mixins.toolbar,
  }),
  showFilter: props => ({
    marginTop: '70px',
  }),
  
  content: props => ({
    flexGrow: 1,
    paddingTop: '8px',
    paddingLeft: props.isMobile ? '0px' : '10px',
    backgroundColor: '#fafafa',
  }),
  navLink: {
    color: 'black',
    textDecoration: 'none'
  }
});

export default styles